import { Tab, TabProps } from '@mui/material';
import React from 'react';

const NavTab = <T extends React.ElementType>(
    props: Omit<TabProps<T, { component?: T }>, 'iconPosition' | 'disableRipple '>,
) => <Tab iconPosition="start" disableRipple {...props} />;

export default NavTab;
